export default "__VITE_ASSET__DIwe3hnC__"